<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="ma-0 pa-0">
      <v-row class="ma-0 pa-0" justify="space-around">
        <v-col cols="12" class="mt-6" v-if="tbl_avaialable">
          <v-row class="ma-0 pa-0">
            <!-- <v-col cols="9" class="ma-0 pa-0">
              <GChart
                style="height: calc(100vh - 380px)"
                type="LineChart"
                :options="portfolio_sos_config"
                :data="portfolio_sos_data"
                :ref="chart_mapping['portfolio_sos_chart']['chart_ref']"
                :key="chart_update_key"
              ></GChart>
            </v-col> -->
            <v-col cols="10" class="ma-0 pa-0">
              <TimeSeriesGraph
                :graph_data="report_dataset['time_series_comparison']"
                :screen_height="time_series_graph_screen_height"
                :chart_ref="chart_mapping['portfolio_time_series_comparison_chart']['chart_ref']"
                :chart_id="chart_mapping['portfolio_time_series_comparison_chart']['chart_id']"
              ></TimeSeriesGraph>
              <!-- <v-chart 
                style="height: calc(100vh - 380px)"
                :option="sos_chart_data"
                autoresize
                :ref="chart_mapping['portfolio_sos_chart']['chart_ref']"
                :id="chart_mapping['portfolio_sos_chart']['chart_id']"
              ></v-chart> -->
            </v-col>
            <v-col cols="2" class="ma-0 pa-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-1 pt-0" style="height: calc((100vh - 404px) / 3);">
                  <SalesOverviewStatistic statistic_title_name="Sales" :data="sales_summary['sales']"></SalesOverviewStatistic>
                </v-col>
                <v-col cols="12" class="ma-0 pa-1 py-2" style="height: calc((100vh - 404px) / 3);">
                  <SalesOverviewStatistic statistic_title_name="Baseline" :data="sales_summary['sos']"></SalesOverviewStatistic>
                </v-col>
                <v-col cols="12" class="ma-0 pa-1 pb-0" style="height: calc((100vh - 404px) / 3);">
                  <SalesOverviewStatistic statistic_title_name="Media Attribution" :data="sales_summary['csos']"></SalesOverviewStatistic>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-6" v-else>
          <v-row class="ma-0 pa-0">
            <v-col cols="10" class="ma-0 pa-0" style="height: calc(100vh - 380px);">
              <v-skeleton-loader
                light
                style="height: calc(100vh - 380px); max-height: none"
                type="image,image,image,image,image,image"
              ></v-skeleton-loader>
            </v-col>
            <v-col cols="2" class="ma-0 pa-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-1 pt-0">
                  <v-skeleton-loader
                    light
                    style="height: calc((100vh - 380px) / 3); max-height: none"
                    type="image,image"
                  ></v-skeleton-loader>
                </v-col>
                <v-col cols="12" class="ma-0 pa-1 py-2">
                  <v-skeleton-loader
                    light
                    style="height: calc((100vh - 380px) / 3); max-height: none"
                    type="image,image"
                  ></v-skeleton-loader>
                </v-col>
                <v-col cols="12" class="ma-0 pa-1 pb-0">
                  <v-skeleton-loader
                    light
                    style="height: calc((100vh - 380px) / 3); max-height: none"
                    type="image,image"
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="ma-0 pb-0">
          <v-card style="height: 100%; max-height: 100%; overflow-y: auto" class="ma-0 pa-0" flat>
            <v-row class="ma-0 pa-0" style="width: 100%;">
              <v-col cols="auto">
                <span class="report-subtitle">Time Series Contribution Comparison</span>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0" style="height: 10px;">
                <v-divider class="mx-12"></v-divider>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0" style="height: calc(100% - 10px);">
                <v-row class="ma-0 pa-0" style="height: 100%;">
                  <!-- <TimeSeriesGraph
                    :graph_data="report_dataset['time_series_comparison']"
                    :screen_height="time_series_screen_height"
                    :chart_ref="chart_mapping['portfolio_time_series_comparison_chart']['chart_ref']"
                    :chart_id="chart_mapping['portfolio_time_series_comparison_chart']['chart_id']"
                  ></TimeSeriesGraph> -->
                  <TimeSeriesStatistics
                    :dataset="report_dataset['qoq_yoy']['qoq']"
                    :screen_height="time_series_screen_height"
                  ></TimeSeriesStatistics>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12">
          <VolumeVsEfficiency
            :dataset="report_dataset['volume_vs_efficiency']"
            :color_palette="cpalette"
            ref="volume_vs_efficiency"
            :chart_ref="chart_mapping['portfolio_volume_vs_efficiency_chart']['chart_ref']"
            :chart_id="chart_mapping['portfolio_volume_vs_efficiency_chart']['chart_id']"
            :chart_update_key="chart_update_key"
          ></VolumeVsEfficiency>
        </v-col>
        <v-col cols="12">
          <ROASContribution
            :dataset="report_dataset['roas_contribution']"
            :color_palette="cpalette"
            ref="roas_contribution"
            :chart_ref="chart_mapping['portfolio_roas_contribution_chart']['chart_ref']"
            :chart_id="chart_mapping['portfolio_roas_contribution_chart']['chart_id']"
            :chart_update_key="chart_update_key"
          ></ROASContribution>
        </v-col>
        <v-col cols="12">
          <TotalUnitsVsCpu
            :dataset="report_dataset['total_units_vs_cpu']"
            :color_palette="cpalette"
            ref="total_units_vs_cpu"
            :chart_ref="chart_mapping['portfolio_total_units_vs_cpu_chart']['chart_ref']"
            :chart_id="chart_mapping['portfolio_total_units_vs_cpu_chart']['chart_id']"
            :chart_update_key="chart_update_key"
          ></TotalUnitsVsCpu>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE } from "@/constants/constants";

import ROASContribution from "./PerformanceReportSections/roas_contribution.vue";
import TimeSeriesGraph from "./PerformanceReportSections/TimeSeriesGraph.vue";
import TimeSeriesStatistics from "./PerformanceReportSections/TimeSeriesStatistics.vue";
import TotalUnitsVsCpu from "./PerformanceReportSections/total_units_vs_cpu.vue";
import VolumeVsEfficiency from "./PerformanceReportSections/volume_vs_efficiency.vue";
import SalesOverviewStatistic from "./PerformanceReportSections/SalesOverviewStatistic.vue";

import chartConfig from "@/configs/Performance/performance_portfolio_sales.json";
import categoryChartConfig from "@/configs/Performance/performance_portfolio_categories.json";
import light_mode_colors from "@/configs/ChartColors/light_mode_colors.json";
import cpalette from "@/configs/ChartColors/get_color_palette.js";

import api_caller from "@/javascript/data_retrieval.js";
// import VChart, { THEME_KEY } from 'vue-echarts';
// import { use } from 'echarts/core';
// import { CanvasRenderer } from 'echarts/renderers'; 'echarts/charts';
// import {
//     TitleComponent,
//     TooltipComponent,
//     LegendComponent,
// } from 'echarts/components';

// use([
//     CanvasRenderer,
//     TitleComponent,
//     TooltipComponent,
//     LegendComponent,
// ]);

export default {
  name: "PerformanceOverview",
  props: ["data_levels", "project_date_range", "project_filters", "chart_mapping", "chart_update_key"],
  components: {
    //VChart,
    ROASContribution,
    TimeSeriesGraph,
    TimeSeriesStatistics,
    TotalUnitsVsCpu,
    VolumeVsEfficiency,
    SalesOverviewStatistic
  },
  provide: {
      // [THEME_KEY]: 'light',
  },
  data: () => ({
    cpalette: "retro",

    performanceDataRaw: null,
    performanceData: [],
    time_series_screen_height: window.innerHeight -404,
    time_series_graph_screen_height: window.innerHeight - 404,
    compareDataRaw: null,
    compare_data: null,
    selected_levels: [],
    selected_fields: [],
    selected_sort_keys: [],
    tbl_avaialable: false,
    toolbar_visible: true,
    portfolio_type: "portfolio",

    views_visible: false,
    selected_view: null,
    save_view: false,
    view_name_tmp: "",
    available_views: [],

    compare: false,
    compare_start_date: null,
    compare_end_date: null,

    portfolio_sos_config: chartConfig,
    portfolio_sos_data: [
      ["date", "sos", "csos", "sales"],
      ["2023-01-01", 50, 70, 100000],
      ["2023-01-08", 40, 60, 150000],
      ["2023-01-15", 60, 50, 175000],
      ["2023-01-22", 55, 55, 200000],
      ["2023-01-29", 60, 57, 200000],
    ],

    portfolio_categories_config: categoryChartConfig,
    portfolio_categories_data: [
      {
        stat: "Channel",
        data: [
          ["cat", "val"],
          ["OOH", 10],
          ["Programmatic", 30],
          ["TV", 40],
          ["DOOH", 50],
        ],
      },
      {
        stat: "Format",
        data: [
          ["cat", "val"],
          ["OOH", 10],
          ["Programmatic", 30],
          ["TV", 40],
          ["DOOH", 50],
        ],
      },
    ],

    report_dataset: {
      spend_impressions_contribution: null,
      spend_impressions_contribution_timing: null,
      roas_contribution: null,
      total_units_vs_cpu: null,
      time_series_comparison: null,
      time_series_comparison_roas: null,
      response_curves: null,
      qoq_yoy: {
        qoq: [],
        yoy: [],
      },
      level_values: [],
    },

    start_date: null,
    end_date: null,
  }),
  mounted() {
    this.portfolio_sos_config["colors"] = light_mode_colors;
    this.portfolio_categories_config["colors"] = light_mode_colors;
    this.refresh_data();
  },
  watch: {
    project_date_range: {
      immediate: true,
      handler: function () {
        this.start_date = this.project_date_range["start_date"];
        this.end_date = this.project_date_range["end_date"];
        // this.refresh_data();
      },
      deep: true,
    },
  },
  computed: {
    available_data_levels: function () {
      if (this.performanceDataRaw == null) {
        return [];
      }
      return Object.keys(this.performanceDataRaw["table_levels"]);
    },
    sos_chart_data: function() {
      let dataset = this.portfolio_sos_data;
      let data_category = [];
      let data_series = [];
      let data = [];
      let series = [];
      if (dataset != null) {
        data = Array.from(Array(dataset[0].length - 1), () => []);
        data_series = dataset[0];
        data_series.shift();

        for (let i = 1; i < dataset.length; i++) {
          data_category.push(dataset[i][0]);

          for (let j = 1; j < dataset[i].length; j++) {
            data[j - 1].push(dataset[i][j]);
          }
        }

        for (let idx = 0; idx < data.length; idx++) {
          series.push({
            name: data_series[idx],
            showSymbol: false,
            type: "line",
            data: data[idx],
            emphasis: {
              focus: "series",
            },
          });
        }
      }

      const option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: data_series,
          type: "scroll"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "4%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: data_category,
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              fontSize: 18,
              fontFamily: "Poppins"
            }
          },
        ],
        yAxis: [
          {
            name: "Search Index",
            nameTextStyle: {
              fontSize: 20,
              fontFamily: "Poppins"
            },
            type: "value",
            axisLabel: {
              fontSize: 18,
              fontFamily: "Poppins"
            }
          },
        ],
        series: series,
        color: cpalette.get_color_palette(this.cpalette)
      };
      return option;
    }
  },
  methods: {
    update_volume_vs_efficiency: async function (levels) {
      this.report_dataset["volume_vs_efficiency"] = null;
      let token = await this.$auth.getTokenSilently();
      let date_range = {
        start_date: this.project_date_range["start_date"],
        end_date: this.project_date_range["end_date"],
      };
      let payload = {
        project_id: this.$project.get_val(),
        level_values: levels,
        data_levels: this.data_levels,
        date_range: date_range,
      };
      let volume_efficiency = await api_caller
        .get_updated_volume_efficiency(token, payload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });
      if (!volume_efficiency) {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE, "PerformanceOverview.get_volume_efficiency");
        return;
      } else {
        this.report_dataset["volume_vs_efficiency"] =
          volume_efficiency["volume_vs_efficiency"];
      }
    },
    refresh_data: async function () {
      this.tbl_avaialable = false;
      this.$emit("update_export_ready", false);
      let date_range = {
        start_date: this.start_date,
        end_date: this.end_date,
      };
      let token = await this.$auth.getTokenSilently();

      let portfolio_overview_data = await api_caller
        .get_portfolio_overview_data(
          token,
          this.$project.get_val(),
          this.data_levels,
          date_range,
          this.project_filters
        )
        .then((resp) => {
          if (typeof resp === "string") {
            return JSON.parse(resp)["data"];
          }
          return resp["data"];
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });

      if (!portfolio_overview_data) {
        this.portfolio_sos_data = [];
      }

      this.report_dataset = portfolio_overview_data;
      this.portfolio_sos_data = portfolio_overview_data["search_sales"];
      this.sales_summary = portfolio_overview_data['sales_summary'];
      this.portfolio_categories_data = portfolio_overview_data["overview"];

      this.reset_table();
      this.$emit("update_export_ready", true);
    },
    reset_table: function () {
      this.tbl_avaialable = false;
      setTimeout(() => (this.tbl_avaialable = true), 100);
    },
  },
};
</script>

<style>
.table-title {
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 1.5em;
}
.report-subtitle {
  color: #1e293b;
  font-family: "Poppins";
  font-size: 1.05em;
  font-weight: 600;
}
.performance_section_title {
  font-family: "Poppins" !important;
  font-weight: 500;
  font-size: 0.9 em;
}
.toolbar_title {
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 1.1em;
}
.toolbar_selector {
  font-family: "Poppins" !important;
  font-weight: 400;
  font-size: 0.9 em;
}
.v-list-item .v-list-item__title {
  font-family: "Poppins" !important;
  font-weight: 400;
  font-size: 0.85em;
}
.scrollable-container {
  overflow-x: auto;
  display: flex;
}
.chart_container {
  overflow: hidden;
}
</style>
